import React from 'react';
import {
  Box,
  Button,
  Grid,
  Link,
  TextField,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from '../forgotPassword.module.scss';

const ForgotPasswordForm = ({resend, onForgotFormSubmit, forgotData, setForgotData, isLoading}) => {

    const formikForgotPass = useFormik({
        initialValues: forgotData,
        validationSchema: Yup.object({
            username: Yup.string()
            .required('Username is required'),
        }),
        onSubmit: onForgotFormSubmit,
    });

    React.useEffect(() => {
        // Submit the form imperatively as an effect as soon as form values.token are 6 digits long
        setForgotData({...setForgotData, username: formikForgotPass.values.username});
    }, [formikForgotPass.values]);
        
    return (
        <Box
          component="form"
          marginTop={3}
          noValidate
          onSubmit={formikForgotPass.handleSubmit}
          data-testid="forgot-pwd-form"
        >
            <label>Please enter your username</label>
            <TextField
                margin="normal"
                variant="outlined"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                disabled={isLoading}
                value={formikForgotPass.values.username}
                onChange={formikForgotPass.handleChange}
                error={formikForgotPass.touched.username && Boolean(formikForgotPass.errors.username)}
                helperText={formikForgotPass.touched.username && formikForgotPass.errors.username}
            />
            
            <Grid container spacing={0} alignItems="center" justifyContent="center">
                <Grid item xs={8}>
                    <Box sx={{ m: 1.5 }}>
                        <Button
                            type="submit"
                            loading={isLoading}
                            data-testid='btn-submit'
                            variant="contained"
                            fullWidth
                            color="primary"
                            className={`${styles['login-btn']}`}
                            disabled={isLoading}
                        >
                            <Box data-testid="login-submit" sx={{fontWeight: 'bold'}}>{!resend ? 'Submit' : 'Resend Mail'}</Box>
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={0} alignItems="center" justifyContent="center">
                <Grid item className={styles['login-with-app']} sx={{ mt: 2 }}>
                    <span>
                        <Link
                            component={RouterLink}
                            to={`/login`}
                            variant="inherit"
                            underline='none'
                            id="link-return-to-login"                    
                        >
                            {'Return to Login Page'}
                        </Link>
                    </span>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ForgotPasswordForm;